import React from "react"
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

 const BookingEmptyImage = ({ height = 140, width = 140, fill = "#F9FBFB", ...props }) => {
  const { adventure_mode } = useSelector((store) => store.user);
  const themeColor = adventure_mode == "sportsman" ? "var(--color-sportsman-brand)" : "var(--color-sportswoman-brand)";
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 140 140" fill="none" {...props}>
    <rect width={width} height={height} rx="70" fill={fill} />
    <path d="M21.25 46.1094L107.368 29.2949L120 93.9935L33.8824 110.808L21.25 46.1094Z" fill={themeColor} />
    <path
      d="M118.095 93.0677L106.456 95.3407C102.548 94.7799 36.7506 107.336 36.7506 107.336L24.8633 48.0057L44.8924 42.7896L105.951 30.8672L118.095 93.0677Z"
      fill="white"
    />
    <path
      d="M106.455 95.3402L35.3006 109.233L23.1562 47.0322L44.8913 42.7891L54.6942 51.1566L54.8296 51.2725L55.5515 51.8883L56.2217 52.4607L58.6958 54.5718L58.7628 54.6291L58.8996 54.7463L58.9667 54.8036L62.5578 57.8683L62.5592 57.8697L62.7295 58.0149L62.7309 58.0163L67.6721 62.2343L67.8076 62.3502L67.809 62.3516L76.0397 69.3774H76.0411L76.2101 69.5212L76.2115 69.5226L76.5815 69.8396L76.7169 69.9554L85.4908 77.4448L85.6262 77.5607L89.5203 80.8851L89.6906 81.0289L89.692 81.0303L94.4001 85.05L94.5369 85.1659L103.001 92.3928H103.002L103.173 92.538L103.309 92.6553L103.443 92.7698L103.445 92.7712L106.455 95.3402Z"
      fill={themeColor}
    />
    <path
      d="M27.8414 47.2674L26.5367 47.5221C26.2899 47.5703 26.1289 47.8094 26.1771 48.0562L26.4842 49.6291C26.5324 49.8759 26.7715 50.0369 27.0183 49.9888L28.323 49.734C28.5698 49.6858 28.7308 49.4467 28.6827 49.1999L28.3755 47.627C28.3274 47.3802 28.0882 47.2192 27.8414 47.2674Z"
      fill="#000066"
    />
    <path
      d="M26.7996 48.7589C26.7015 48.7589 26.6138 48.6895 26.5942 48.5895L25.6797 43.906C25.6575 43.7925 25.7316 43.6825 25.8452 43.6603C25.9587 43.6377 26.0687 43.7122 26.0909 43.8257L27.0054 48.5092C27.0276 48.6228 26.9535 48.7328 26.84 48.755C26.8264 48.7576 26.8129 48.7589 26.7996 48.7589Z"
      fill="white"
    />
    <path
      d="M27.9793 48.5286C27.8812 48.5286 27.7935 48.4592 27.7739 48.3592L26.8594 43.6756C26.8372 43.562 26.9113 43.452 27.0248 43.4298C27.1384 43.4072 27.2484 43.4818 27.2706 43.5953L28.1851 48.2789C28.2073 48.3924 28.1332 48.5025 28.0197 48.5247C28.0061 48.5273 27.9926 48.5286 27.9793 48.5286Z"
      fill="white"
    />
    <path
      d="M35.357 45.8025L34.0523 46.0573C33.8055 46.1055 33.6445 46.3446 33.6927 46.5914L33.9998 48.1643C34.048 48.4111 34.2871 48.5721 34.5339 48.5239L35.8387 48.2692C36.0855 48.221 36.2465 47.9818 36.1983 47.735L35.8912 46.1622C35.843 45.9154 35.6039 45.7543 35.357 45.8025Z"
      fill="#000066"
    />
    <path
      d="M34.3172 47.2903C34.219 47.2903 34.1314 47.2209 34.1118 47.1209L33.1973 42.4373C33.1751 42.3238 33.2492 42.2137 33.3627 42.1915C33.4763 42.1689 33.5863 42.2435 33.6085 42.357L34.523 47.0406C34.5452 47.1542 34.4711 47.2642 34.3576 47.2864C34.344 47.289 34.3305 47.2903 34.3172 47.2903Z"
      fill="white"
    />
    <path
      d="M35.4969 47.0597C35.3987 47.0597 35.3111 46.9903 35.2915 46.8904L34.377 42.2069C34.3548 42.0933 34.4289 41.9833 34.5424 41.9611C34.6561 41.9384 34.766 42.0131 34.7882 42.1266L35.7027 46.8101C35.7249 46.9236 35.6508 47.0336 35.5372 47.0558C35.5237 47.0585 35.5102 47.0597 35.4969 47.0597Z"
      fill="white"
    />
    <path
      d="M42.8727 44.3338L41.568 44.5885C41.3212 44.6367 41.1602 44.8759 41.2083 45.1227L41.5155 46.6955C41.5636 46.9423 41.8028 47.1033 42.0496 47.0552L43.3543 46.8004C43.6011 46.7522 43.7621 46.5131 43.7139 46.2663L43.4068 44.6934C43.3586 44.4466 43.1195 44.2856 42.8727 44.3338Z"
      fill="#000066"
    />
    <path
      d="M41.8309 45.8214C41.7327 45.8214 41.645 45.752 41.6255 45.6521L40.711 40.9686C40.6888 40.8551 40.7629 40.745 40.8764 40.7228C40.9901 40.7001 41.0999 40.7748 41.1221 40.8883L42.0367 45.5718C42.0589 45.6853 41.9847 45.7953 41.8712 45.8175C41.8577 45.8202 41.8441 45.8214 41.8309 45.8214Z"
      fill="white"
    />
    <path
      d="M43.0145 45.591C42.9163 45.591 42.8286 45.5216 42.8091 45.4216L41.8946 40.7381C41.8724 40.6246 41.9465 40.5146 42.06 40.4924C42.1735 40.4696 42.2835 40.5443 42.3057 40.6578L43.2203 45.3413C43.2425 45.4548 43.1683 45.5649 43.0548 45.5871C43.0413 45.5897 43.0277 45.591 43.0145 45.591Z"
      fill="white"
    />
    <path
      d="M50.3883 42.865L49.0836 43.1198C48.8368 43.168 48.6758 43.4071 48.724 43.6539L49.0311 45.2268C49.0793 45.4736 49.3184 45.6346 49.5652 45.5864L50.8699 45.3317C51.1167 45.2835 51.2777 45.0443 51.2295 44.7975L50.9224 43.2247C50.8742 42.9779 50.6351 42.8168 50.3883 42.865Z"
      fill="#000066"
    />
    <path
      d="M49.3485 44.3566C49.2503 44.3566 49.1626 44.2872 49.1431 44.1872L48.2285 39.5037C48.2063 39.3902 48.2805 39.2802 48.394 39.258C48.5075 39.2352 48.6175 39.3099 48.6397 39.4234L49.5543 44.1069C49.5765 44.2205 49.5023 44.3305 49.3888 44.3527C49.3753 44.3553 49.3617 44.3566 49.3485 44.3566Z"
      fill="white"
    />
    <path
      d="M50.5281 44.126C50.43 44.126 50.3423 44.0566 50.3228 43.9566L49.4082 39.2731C49.386 39.1596 49.4602 39.0496 49.5737 39.0274C49.6872 39.0051 49.7972 39.0793 49.8194 39.1929L50.7339 43.8764C50.7561 43.9899 50.682 44.0999 50.5685 44.1221C50.5549 44.1248 50.5414 44.126 50.5281 44.126Z"
      fill="white"
    />
    <path
      d="M57.9059 41.4002L56.6012 41.6549C56.3544 41.7031 56.1934 41.9423 56.2415 42.1891L56.5487 43.7619C56.5968 44.0087 56.836 44.1698 57.0828 44.1216L58.3875 43.8668C58.6343 43.8186 58.7953 43.5795 58.7471 43.3327L58.44 41.7598C58.3918 41.513 58.1527 41.352 57.9059 41.4002Z"
      fill="#000066"
    />
    <path
      d="M56.8659 42.8877C56.7677 42.8877 56.6801 42.8183 56.6605 42.7184L55.7461 38.0349C55.7239 37.9213 55.7981 37.8113 55.9116 37.7891C56.0251 37.7668 56.1351 37.8411 56.1573 37.9546L57.0717 42.6381C57.0939 42.7516 57.0198 42.8616 56.9062 42.8838C56.8927 42.8865 56.8792 42.8877 56.8659 42.8877Z"
      fill="white"
    />
    <path
      d="M58.0457 42.6573C57.9476 42.6573 57.8599 42.5879 57.8403 42.4879L56.9258 37.8044C56.9036 37.6909 56.9777 37.5809 57.0913 37.5587C57.2049 37.5363 57.3148 37.6106 57.337 37.7241L58.2515 42.4076C58.2737 42.5211 58.1996 42.6311 58.0861 42.6533C58.0725 42.656 58.059 42.6573 58.0457 42.6573Z"
      fill="white"
    />
    <path
      d="M65.4215 39.9314L64.1168 40.1862C63.87 40.2344 63.709 40.4735 63.7572 40.7203L64.0643 42.2932C64.1125 42.54 64.3516 42.701 64.5984 42.6528L65.9031 42.3981C66.1499 42.3499 66.3109 42.1108 66.2627 41.8639L65.9556 40.2911C65.9074 40.0443 65.6683 39.8833 65.4215 39.9314Z"
      fill="#000066"
    />
    <path
      d="M64.3817 41.419C64.2835 41.419 64.1958 41.3496 64.1763 41.2496L63.2617 36.5661C63.2395 36.4526 63.3137 36.3426 63.4272 36.3204C63.5408 36.298 63.6507 36.3723 63.6729 36.4858L64.5875 41.1693C64.6097 41.2828 64.5355 41.3929 64.422 41.4151C64.4085 41.4177 64.3949 41.419 64.3817 41.419Z"
      fill="white"
    />
    <path
      d="M65.5594 41.1885C65.4612 41.1885 65.3735 41.1192 65.354 41.0192L64.4395 36.3357C64.4173 36.2222 64.4914 36.1121 64.6049 36.0899C64.7184 36.0675 64.8285 36.1419 64.8507 36.2554L65.7652 40.9389C65.7874 41.0524 65.7133 41.1624 65.5997 41.1846C65.5862 41.1873 65.5727 41.1885 65.5594 41.1885Z"
      fill="white"
    />
    <path
      d="M72.9391 38.4627L71.6344 38.7174C71.3876 38.7656 71.2266 39.0048 71.2748 39.2516L71.5819 40.8244C71.63 41.0712 71.8692 41.2323 72.116 41.1841L73.4207 40.9293C73.6675 40.8811 73.8285 40.642 73.7803 40.3952L73.4732 38.8223C73.425 38.5755 73.1859 38.4145 72.9391 38.4627Z"
      fill="#000066"
    />
    <path
      d="M71.8973 39.9542C71.7991 39.9542 71.7114 39.8848 71.6919 39.7848L70.7774 35.1013C70.7552 34.9878 70.8293 34.8778 70.9428 34.8556C71.0563 34.8331 71.1664 34.9075 71.1886 35.021L72.1031 39.7045C72.1253 39.818 72.0511 39.9281 71.9376 39.9503C71.9241 39.9529 71.9105 39.9542 71.8973 39.9542Z"
      fill="white"
    />
    <path
      d="M73.0768 39.7237C72.9787 39.7237 72.891 39.6543 72.8714 39.5543L71.9571 34.8708C71.9349 34.7573 72.009 34.6473 72.1225 34.6251C72.236 34.6026 72.346 34.677 72.3682 34.7906L73.2826 39.4741C73.3048 39.5876 73.2307 39.6976 73.1172 39.7198C73.1036 39.7224 73.0901 39.7237 73.0768 39.7237Z"
      fill="white"
    />
    <path
      d="M80.4528 36.9978L79.148 37.2526C78.9012 37.3008 78.7402 37.5399 78.7884 37.7867L79.0955 39.3596C79.1437 39.6064 79.3829 39.7674 79.6297 39.7192L80.9344 39.4645C81.1812 39.4163 81.3422 39.1772 81.294 38.9304L80.9869 37.3575C80.9387 37.1107 80.6996 36.9497 80.4528 36.9978Z"
      fill="#000066"
    />
    <path
      d="M79.4129 38.4854C79.3147 38.4854 79.2271 38.416 79.2075 38.3161L78.293 33.6326C78.2708 33.519 78.3449 33.409 78.4584 33.3868C78.5721 33.3643 78.682 33.4388 78.7042 33.5523L79.6187 38.2358C79.6409 38.3493 79.5668 38.4593 79.4533 38.4815C79.4397 38.4842 79.4262 38.4854 79.4129 38.4854Z"
      fill="white"
    />
    <path
      d="M80.5945 38.2551C80.4964 38.2551 80.4087 38.1857 80.3892 38.0857L79.4746 33.4021C79.4524 33.2886 79.5266 33.1786 79.6401 33.1564C79.7537 33.1339 79.8636 33.2083 79.8858 33.3218L80.8003 38.0054C80.8225 38.119 80.7484 38.229 80.6349 38.2512C80.6214 38.2538 80.6078 38.2551 80.5945 38.2551Z"
      fill="white"
    />
    <path
      d="M87.9703 35.5291L86.6656 35.7838C86.4188 35.832 86.2578 36.0712 86.306 36.318L86.6131 37.8909C86.6613 38.1377 86.9004 38.2987 87.1472 38.2505L88.4519 37.9957C88.6987 37.9475 88.8597 37.7084 88.8116 37.4616L88.5045 35.8887C88.4563 35.6419 88.2171 35.4809 87.9703 35.5291Z"
      fill="#000066"
    />
    <path
      d="M86.9285 37.0167C86.8304 37.0167 86.7427 36.9473 86.7231 36.8473L85.8086 32.1638C85.7864 32.0503 85.8606 31.9403 85.9741 31.9181C86.0877 31.8956 86.1976 31.97 86.2198 32.0835L87.1343 36.767C87.1565 36.8805 87.0824 36.9906 86.9689 37.0128C86.9553 37.0154 86.9418 37.0167 86.9285 37.0167Z"
      fill="white"
    />
    <path
      d="M88.1082 36.7862C88.0101 36.7862 87.9224 36.7168 87.9028 36.6169L86.9883 31.9334C86.9661 31.8199 87.0402 31.7098 87.1538 31.6876C87.2673 31.665 87.3773 31.7396 87.3995 31.8531L88.314 36.5366C88.3362 36.6501 88.2621 36.7601 88.1486 36.7823C88.135 36.785 88.1215 36.7862 88.1082 36.7862Z"
      fill="white"
    />
    <path
      d="M95.484 34.0603L94.1793 34.3151C93.9325 34.3633 93.7715 34.6024 93.8197 34.8492L94.1268 36.4221C94.175 36.6689 94.4141 36.8299 94.6609 36.7817L95.9656 36.527C96.2124 36.4788 96.3734 36.2397 96.3252 35.9929L96.0181 34.42C95.9699 34.1732 95.7308 34.0122 95.484 34.0603Z"
      fill="#000066"
    />
    <path
      d="M94.4442 35.5519C94.346 35.5519 94.2583 35.4825 94.2388 35.3825L93.3242 30.699C93.302 30.5855 93.3762 30.4755 93.4897 30.4533C93.6032 30.4306 93.7132 30.5052 93.7354 30.6187L94.65 35.3022C94.6722 35.4157 94.598 35.5258 94.4845 35.548C94.471 35.5506 94.4574 35.5519 94.4442 35.5519Z"
      fill="white"
    />
    <path
      d="M95.6258 35.3214C95.5276 35.3214 95.44 35.252 95.4204 35.152L94.5059 30.4685C94.4837 30.355 94.5578 30.245 94.6713 30.2228C94.7848 30.2002 94.8949 30.2747 94.9171 30.3882L95.8316 35.0718C95.8538 35.1853 95.7797 35.2953 95.6661 35.3175C95.6526 35.3201 95.6391 35.3214 95.6258 35.3214Z"
      fill="white"
    />
    <path
      d="M103.002 32.5955L101.697 32.8502C101.45 32.8984 101.289 33.1376 101.337 33.3844L101.644 34.9573C101.693 35.2041 101.932 35.3651 102.178 35.3169L103.483 35.0621C103.73 35.0139 103.891 34.7748 103.843 34.528L103.536 32.9551C103.488 32.7083 103.248 32.5473 103.002 32.5955Z"
      fill="#000066"
    />
    <path
      d="M101.962 34.0831C101.864 34.0831 101.776 34.0137 101.756 33.9138L100.842 29.2303C100.82 29.1167 100.894 29.0067 101.007 28.9845C101.121 28.9619 101.231 29.0365 101.253 29.15L102.168 33.8335C102.19 33.947 102.116 34.057 102.002 34.0792C101.989 34.0819 101.975 34.0831 101.962 34.0831Z"
      fill="white"
    />
    <path
      d="M103.139 33.8525C103.041 33.8525 102.954 33.7831 102.934 33.6832L102.02 28.9997C101.997 28.8862 102.071 28.7761 102.185 28.7539C102.299 28.7317 102.409 28.8059 102.431 28.9194L103.345 33.6029C103.367 33.7164 103.293 33.8264 103.18 33.8486C103.166 33.8513 103.153 33.8525 103.139 33.8525Z"
      fill="white"
    />
    <path d="M56.2028 52.3669L56.221 52.4633L55.5508 51.8908L56.799 51.6562L56.9079 52.2343L56.2028 52.3669Z" fill={themeColor} />
    <path
      d="M56.5695 54.3075L55.99 54.4164L55.6242 52.4756L54.982 52.5971L54.873 52.0191L55.5516 51.8906L56.2218 52.4631L56.5695 54.3075Z"
      fill="#000066"
    />
    <path
      d="M78.2118 50.0822L77.633 50.1913L77.2675 48.2504L76.6248 48.3714L76.5156 47.7926L78.4431 47.4297L78.5522 48.0084L77.8461 48.1415L78.2115 50.0822H78.2118Z"
      fill={themeColor}
    />
    <path
      d="M88.4664 47.6662L87.8876 47.7752L87.8298 47.4688C87.7396 46.9902 88.0557 46.5273 88.5345 46.4373L88.9892 46.3516L89.0982 46.9303L88.6434 47.016C88.4838 47.046 88.3784 47.2003 88.4086 47.3599L88.4664 47.6662Z"
      fill={themeColor}
    />
    <path
      d="M88.5415 48.0618L87.9627 48.1707L87.4883 45.6511L89.1202 45.3438L89.2291 45.9225L88.1759 46.1209L88.5415 48.0618Z"
      fill={themeColor}
    />
    <path
      d="M45.7843 56.4113L45.2056 56.5202L44.8812 54.7975C44.8586 54.6773 44.7423 54.5977 44.6221 54.6205L44.0763 54.7232L44.4364 56.6351L43.8577 56.744L43.3887 54.2533L44.5132 54.0414C44.9524 53.9587 45.3775 54.2489 45.4601 54.6883L45.7845 56.411L45.7843 56.4113Z"
      fill="#000066"
    />
    <path
      d="M47.1414 56.1532L46.5627 56.2621L46.2384 54.5394C46.2157 54.4192 46.0994 54.3396 45.9792 54.3624L45.704 54.4142C45.5549 54.4422 45.4563 54.5865 45.4844 54.7357L45.7934 56.377L45.2146 56.4859L44.9057 54.8446C44.8174 54.3763 45.1267 53.9235 45.5951 53.8354L45.8703 53.7836C46.3097 53.7008 46.7346 53.9911 46.8172 54.4305L47.1414 56.1532Z"
      fill="#000066"
    />
    <path
      d="M68.7746 51.9319L67.65 52.1437C67.2106 52.2265 66.7858 51.9363 66.7032 51.4969L66.3789 49.7741L66.9576 49.6652L67.282 51.388C67.3046 51.5082 67.4209 51.5877 67.5411 51.5649L68.0869 51.4622L67.7268 49.5503L68.3056 49.4414L68.7746 51.9319Z"
      fill={themeColor}
    />
    <path
      d="M66.5678 52.3456L66.2926 52.3974C65.8534 52.4802 65.4283 52.1901 65.3458 51.7507L65.0215 50.0279L65.6002 49.919L65.9246 51.6418C65.9472 51.762 66.0635 51.8415 66.1837 51.8187L66.4589 51.7669C66.608 51.7388 66.7066 51.5946 66.6785 51.4455L66.3695 49.8042L66.9483 49.6953L67.2573 51.3366C67.3454 51.8047 67.0361 52.2575 66.5678 52.3456Z"
      fill={themeColor}
    />
    <path
      d="M34.8983 58.7697L33.8017 58.976L33.6928 58.3973L34.7894 58.1909C34.9096 58.1683 34.9892 58.052 34.9664 57.9318L34.9586 57.8905C34.936 57.7702 34.8197 57.6908 34.6994 57.7135L33.5483 57.9304L33.4106 57.1992C33.3278 56.7599 33.6181 56.3351 34.0575 56.2523L35.1274 56.0508L35.2363 56.6295L34.1664 56.831C34.0462 56.8536 33.9667 56.9698 33.9893 57.0901L34.0181 57.2426L34.5905 57.1348C35.0298 57.052 35.4548 57.3422 35.5373 57.7815L35.5451 57.8229C35.6277 58.2621 35.3375 58.6869 34.8983 58.7697Z"
      fill="#000066"
    />
    <path
      d="M99.7869 45.8986L98.6903 46.1049L98.5814 45.5262L99.678 45.3198C99.7983 45.2972 99.8778 45.1809 99.8551 45.0607L99.8473 45.0194C99.8246 44.8991 99.7083 44.8197 99.5881 44.8425L98.4369 45.0593L98.2993 44.3281C98.2165 43.8887 98.5067 43.464 98.9461 43.3812L100.016 43.1797L100.125 43.7584L99.055 43.9599C98.9348 43.9825 98.8554 44.0987 98.878 44.219L98.9068 44.3715L99.4792 44.2637C99.9185 44.1809 100.343 44.4711 100.426 44.9104L100.434 44.9518C100.516 45.3909 100.226 45.8158 99.7869 45.8986Z"
      fill={themeColor}
    />
    <path
      d="M103.309 92.6588L38.2705 105.357L28.7063 56.3765L54.8297 51.276L54.6943 51.1602L28.6114 56.2522L28.543 56.2662L38.1462 105.452L38.1602 105.521L103.445 92.7747L103.309 92.6588Z"
      fill="#000066"
    />
    <path
      d="M114.049 90.7039L113.98 90.7179L103.446 92.7745L103.311 92.6586L113.884 90.5936L104.321 41.6126L54.8307 51.2759L54.6953 51.16L104.432 41.4492L104.444 41.5176L114.049 90.7039Z"
      fill={themeColor}
    />
    <path d="M105.204 45.7776L58.9662 54.8056L58.6953 54.5738L105.151 45.5039L105.204 45.7776Z" fill={themeColor} />
    <path d="M58.9649 54.806L29.4529 60.5682L29.3984 60.2946L58.6941 54.5742L58.9649 54.806Z" fill="#000066" />
    <path
      d="M31.1299 69.5127L29.3457 60.3742L29.4143 60.3607L40.3043 58.2344L42.0885 67.3728L42.0199 67.3864L31.1299 69.5127ZM29.5095 60.4844L31.2402 69.3488L41.9247 67.2628L40.194 58.3984L29.5095 60.4844Z"
      fill="#000066"
    />
    <path
      d="M41.9503 67.3994L40.166 58.2609L40.2346 58.2474L51.1246 56.1211L52.9088 65.2595L52.8403 65.2731L41.9503 67.3994ZM40.3298 58.3711L42.0606 67.2355L52.745 65.1495L51.0143 56.2851L40.3298 58.3711Z"
      fill="#000066"
    />
    <path
      d="M62.7305 58.0162L62.5588 57.8695L63.5669 63.0356L52.883 65.1215L51.1516 56.2583L58.8993 54.7462L58.7625 54.6289L51.0567 56.134L50.9883 56.148L52.7727 65.2863L63.6618 63.1599L63.7316 63.1459L62.7305 58.0162Z"
      fill="#000066"
    />
    <path
      d="M62.7298 58.0164L62.5581 57.8698L61.8362 54.1726L58.8986 54.7464L58.7617 54.6291L61.9465 54.0078L62.7298 58.0164Z"
      fill={themeColor}
    />
    <path
      d="M67.673 62.2371L63.7049 63.012L62.7303 58.0177L62.56 57.8725L62.5586 57.8711L63.5946 63.1768L67.8098 62.3544L67.673 62.2371Z"
      fill="#000066"
    />
    <path
      d="M74.552 61.0367L74.4835 61.0507L67.8082 62.3548L67.6713 62.2375L74.3886 60.9264L72.6573 52.0618L61.9733 54.1478L62.7287 58.0181L62.5584 57.8729L62.557 57.8715L61.8086 54.0375L61.8784 54.0249L72.7676 51.8984L74.552 61.0367Z"
      fill={themeColor}
    />
    <path
      d="M74.417 61.0633L72.6328 51.925L72.7014 51.9115L83.5914 49.7852L85.3756 58.9236L85.3071 58.9371L74.417 61.0633ZM72.7966 52.0352L74.5274 60.8994L85.2118 58.8134L83.4811 49.9491L72.7966 52.0352Z"
      fill={themeColor}
    />
    <path
      d="M85.2374 58.9502L83.4531 49.8117L83.5217 49.7982L94.4118 47.6719L96.1961 56.8103L96.1275 56.8239L85.2375 58.9502H85.2374ZM83.6169 49.9219L85.3477 58.7863L96.0321 56.7003L94.3014 47.8359L83.6169 49.9219Z"
      fill={themeColor}
    />
    <path
      d="M96.0596 56.8369L94.2754 47.6985L94.3439 47.6849L105.234 45.5586L107.018 54.697L106.95 54.7106L96.0596 56.8369ZM94.4392 47.8086L96.1699 56.673L106.854 54.587L105.124 45.7227L94.4392 47.8086Z"
      fill={themeColor}
    />
    <path
      d="M32.8878 78.5166L31.1035 69.3781L31.1721 69.3646L42.0622 67.2383L43.8465 76.3767L43.7779 76.3903L32.8878 78.5166ZM31.2673 69.4883L32.9981 78.3527L43.6825 76.2667L41.9518 67.4023L31.2673 69.4883Z"
      fill="#000066"
    />
    <path
      d="M43.7081 76.4033L41.9238 67.2649L41.9924 67.2513L52.8824 65.125L54.6666 74.2633L54.5981 74.2768L43.7081 76.4032V76.4033ZM42.0876 67.375L43.8184 76.2394L54.5028 74.1533L52.7721 65.2891L42.0876 67.375Z"
      fill="#000066"
    />
    <path
      d="M54.5303 74.2899L52.7461 65.1516L52.8147 65.138L63.7047 63.0117L65.4889 72.15L65.4203 72.1636L54.5303 74.2899ZM52.9099 65.2617L54.6406 74.126L65.3251 72.04L63.5944 63.1758L52.9099 65.2617Z"
      fill="#000066"
    />
    <path
      d="M76.2092 69.5213L76.0403 69.3775L76.1464 69.9248L65.4611 72.0108L63.7312 63.1461L67.8067 62.3503L67.6713 62.2344L63.6348 63.0232L63.5664 63.0358L65.3508 72.1741L76.2414 70.0491L76.3098 70.0351L76.2092 69.5213Z"
      fill="#000066"
    />
    <path
      d="M76.2118 69.5229L76.0428 69.3791H76.0414L74.4176 61.0618L67.8093 62.3519L67.6738 62.236L74.5279 60.8984L76.2118 69.5229Z"
      fill={themeColor}
    />
    <path
      d="M76.5808 69.8411L76.2834 69.8997L76.2108 69.5241L76.0391 69.3789L76.1731 70.0631L76.7162 69.9569L76.5808 69.8411Z"
      fill="#000066"
    />
    <path
      d="M87.1326 67.9249L87.0642 67.9374L76.7181 69.9578L76.5827 69.8419L86.9692 67.8146L85.2379 58.9499L74.554 61.0359L76.2127 69.5249L76.041 69.3797L74.3906 60.9256L74.459 60.9116L85.3482 58.7852L87.1326 67.9249Z"
      fill={themeColor}
    />
    <path
      d="M86.9952 67.9502L85.2109 58.8117L85.2795 58.7982L96.1695 56.6719L97.9537 65.8103L97.8852 65.8239L86.995 67.9502H86.9952ZM85.3747 58.9219L87.1055 67.7863L97.79 65.7003L96.0592 56.8359L85.3747 58.9219Z"
      fill={themeColor}
    />
    <path
      d="M97.8174 65.8369L96.0332 56.6984L96.1018 56.6849L106.992 54.5586L108.776 63.697L108.707 63.7106L97.8174 65.8369ZM96.197 56.8086L97.9277 65.673L108.612 63.587L106.881 54.7226L96.197 56.8086Z"
      fill={themeColor}
    />
    <path
      d="M34.6456 87.5164L32.8613 78.3781L32.9299 78.3646L43.8199 76.2383L45.6041 85.3766L45.5356 85.3901L34.6456 87.5164ZM33.0251 78.4883L34.7559 87.3525L45.4404 85.2666L43.7096 76.4023L33.0251 78.4883Z"
      fill="#000066"
    />
    <path
      d="M45.4659 85.4032L43.6816 76.2649L43.7502 76.2513L54.6402 74.125L56.4244 83.2634L56.3559 83.277L45.4659 85.4033V85.4032ZM43.8454 76.375L45.5762 85.2392L56.2607 83.1533L54.5299 74.2889L43.8454 76.375Z"
      fill="#000066"
    />
    <path
      d="M56.2881 83.29L54.5039 74.1516L54.5725 74.138L65.4625 72.0117L67.2467 81.1502L67.1781 81.1637L56.2881 83.29ZM54.6677 74.2617L56.3984 83.1261L67.0829 81.0401L65.3522 72.1758L54.6677 74.2617Z"
      fill="#000066"
    />
    <path
      d="M67.1085 81.1767L65.3242 72.0383L65.3928 72.0248L76.2828 69.8984L78.067 79.0369L77.9985 79.0504L67.1085 81.1767ZM65.488 72.1485L67.2188 81.0128L77.9032 78.9269L76.1725 70.0625L65.488 72.1485Z"
      fill="#000066"
    />
    <path
      d="M85.49 77.4451L78.0398 78.9L76.3098 70.0353L76.7161 69.9557L76.5807 69.8398L76.2149 69.9111L76.1465 69.925L77.9295 79.0633L85.6255 77.561L85.49 77.4451Z"
      fill="#000066"
    />
    <path
      d="M88.8898 76.9249L88.8214 76.9374L85.6268 77.5615L85.4914 77.4456L88.7264 76.8146L86.9951 67.9499L76.7175 69.9563L76.582 69.8404L87.1054 67.7852L88.8898 76.9249Z"
      fill={themeColor}
    />
    <path
      d="M88.753 76.9502L86.9688 67.8117L87.0373 67.7982L97.9275 65.6719L99.7117 74.8103L99.6431 74.8239L88.7531 76.9502H88.753ZM87.1325 67.9219L88.8633 76.7863L99.5478 74.7003L97.817 65.8359L87.1325 67.9219Z"
      fill={themeColor}
    />
    <path
      d="M99.5753 74.8408L97.791 65.7024L97.8596 65.6888L108.75 63.5625L110.534 72.7009L110.465 72.7145L99.5753 74.8408ZM97.9548 65.8125L99.6856 74.6769L110.37 72.5909L108.639 63.7266L97.9548 65.8125Z"
      fill={themeColor}
    />
    <path
      d="M36.4034 96.5166L34.6191 87.3781L34.6877 87.3646L45.5778 85.2383L47.3621 94.3767L47.2935 94.3903L36.4034 96.5166ZM34.7829 87.4883L36.5137 96.3527L47.1982 94.2667L45.4674 85.4023L34.7829 87.4883Z"
      fill="#000066"
    />
    <path
      d="M47.2237 94.4033L45.4395 85.2649L45.508 85.2513L56.398 83.125L58.1823 92.2634L58.1137 92.277L47.2237 94.4033ZM45.6032 85.375L47.334 94.2394L58.0185 92.1534L56.2877 83.2891L45.6032 85.375Z"
      fill="#000066"
    />
    <path
      d="M58.044 92.2939L56.2598 83.1555L56.3283 83.1419L67.2183 81.0156L69.0026 90.1541L68.934 90.1676L58.044 92.2939ZM56.4235 83.2656L58.1543 92.13L68.8388 90.044L67.108 81.1797L56.4235 83.2656Z"
      fill="#000066"
    />
    <path
      d="M68.8663 90.1806L67.082 81.0422L67.1506 81.0287L78.0406 78.9023L79.8248 88.0408L79.7563 88.0543L68.8663 90.1806ZM67.2458 81.1524L68.9766 90.0167L79.6611 87.9308L77.9303 79.0664L67.2458 81.1524Z"
      fill="#000066"
    />
    <path
      d="M89.6907 81.0308L89.519 80.8856L90.4823 85.8157L79.797 87.9017L78.0671 79.037L85.6249 77.5612L85.4894 77.4453L77.9708 78.9127L77.9023 78.9267L79.6867 88.065L90.5773 85.9386L90.6457 85.926L89.6907 81.0308Z"
      fill="#000066"
    />
    <path
      d="M89.6915 81.0336L89.5197 80.8884L88.7518 76.9538L85.6257 77.564L85.4902 77.4481L88.8621 76.7891L89.6915 81.0336Z"
      fill={themeColor}
    />
    <path
      d="M94.4013 85.0517L90.6217 85.7889L89.6932 81.0319L89.6918 81.0305L89.5215 80.8867L90.5114 85.9536L94.5381 85.1676L94.4013 85.0517Z"
      fill="#000066"
    />
    <path
      d="M101.469 83.8141L101.4 83.828L94.5377 85.1684L94.4008 85.0525L101.305 83.7038L99.5752 74.8405L88.8899 76.9265L89.6914 81.0314L89.521 80.8876L88.7266 76.8162L88.795 76.8022L99.6855 74.6758L101.469 83.8141Z"
      fill={themeColor}
    />
    <path
      d="M101.331 83.8408L99.5469 74.7024L99.6154 74.6888L110.505 72.5625L112.29 81.7009L112.221 81.7145L101.331 83.8408ZM99.7106 74.8125L101.441 83.6769L112.126 81.5909L110.395 72.7266L99.7106 74.8125Z"
      fill={themeColor}
    />
    <path
      d="M38.1592 105.517L36.375 96.3781L36.4436 96.3646L47.3336 94.2383L49.1178 103.377L49.0492 103.39L38.1592 105.517ZM36.5388 96.4883L38.2695 105.353L48.954 103.267L47.2233 94.4023L36.5388 96.4883Z"
      fill="#000066"
    />
    <path
      d="M48.9795 103.407L47.1953 94.2688L47.2639 94.2552L58.1539 92.1289L59.9381 101.267L59.8696 101.281L48.9795 103.407ZM47.3591 94.3789L49.0899 103.243L59.7743 101.157L58.0436 92.293L47.3591 94.3789Z"
      fill="#000066"
    />
    <path
      d="M59.8018 101.294L58.0176 92.1555L58.0861 92.1419L68.9761 90.0156L70.7604 99.1541L70.6918 99.1676L59.8018 101.294ZM58.1814 92.2656L59.9121 101.13L70.5966 99.0441L68.8658 90.1797L58.1814 92.2656Z"
      fill="#000066"
    />
    <path
      d="M70.6221 99.1806L68.8379 90.0422L68.9064 90.0287L79.7965 87.9023L81.5807 97.0408L81.5121 97.0543L70.6221 99.1806ZM69.0017 90.1524L70.7324 99.0167L81.4169 96.9308L79.6862 88.0664L69.0017 90.1524Z"
      fill="#000066"
    />
    <path
      d="M81.4444 97.0674L79.6602 87.9289L79.7287 87.9154L90.6187 85.7891L92.403 94.9275L92.3344 94.941L81.4444 97.0674ZM79.8239 88.0391L81.5547 96.9034L92.2392 94.8175L90.5084 85.9531L79.8239 88.0391Z"
      fill="#000066"
    />
    <path
      d="M103.169 92.5387L102.999 92.3935L103.059 92.7035L92.3751 94.7895L90.6438 85.9262L94.5337 85.1667L94.3969 85.0508L90.5489 85.802L90.4805 85.8159L92.2648 94.9542L103.154 92.8278L103.222 92.8138L103.169 92.5387Z"
      fill="#000066"
    />
    <path
      d="M103.173 92.539L103.003 92.3938L101.331 83.8405L94.5372 85.167L94.4004 85.0511L101.442 83.6758L103.173 92.539Z"
      fill={themeColor}
    />
    <path
      d="M103.311 92.657L103.201 92.678L103.174 92.5397L103.004 92.3945L103.09 92.8413L103.445 92.7715L103.311 92.657Z"
      fill="#000066"
    />
    <path
      d="M114.048 90.7008L113.98 90.7148L103.444 92.77L103.31 92.6555L113.883 90.5905L112.153 81.7259L101.468 83.8118L103.173 92.5382L103.002 92.393H103.001L101.305 83.7015L101.373 83.689L112.264 81.5625L114.048 90.7008Z"
      fill={themeColor}
    />
    <path d="M39.377 54.2188L39.514 54.192L40.3934 58.6962L40.2564 58.723L39.377 54.2188Z" fill="#000066" />
    <path d="M50.1973 52.1055L50.3343 52.0787L51.2137 56.5829L51.0767 56.6097L50.1973 52.1055Z" fill="#000066" />
    <path d="M61.0195 49.9922L61.1566 49.9654L62.036 54.4696L61.899 54.4964L61.0195 49.9922Z" fill={themeColor} />
    <path d="M71.8398 47.8828L71.9769 47.8561L72.8563 52.3603L72.7193 52.387L71.8398 47.8828Z" fill={themeColor} />
    <path d="M82.6641 45.7695L82.8011 45.7428L83.6806 50.2471L83.5435 50.2739L82.6641 45.7695Z" fill={themeColor} />
    <path d="M93.4844 43.6562L93.6214 43.6295L94.5009 48.1338L94.3638 48.1606L93.4844 43.6562Z" fill={themeColor} />
    <path
      d="M47.2248 64.1021L44.8125 62.4271L44.9718 62.1977L47.0615 63.6488L48.3186 59.1523L48.5875 59.2275L47.2248 64.1021Z"
      fill="#000066"
    />
    </svg>
)
 }
BookingEmptyImage.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string,
};

export default BookingEmptyImage